import { render, staticRenderFns } from "./ReviewViewer.vue?vue&type=template&id=64833276&scoped=true&"
import script from "./ReviewViewer.vue?vue&type=script&lang=js&"
export * from "./ReviewViewer.vue?vue&type=script&lang=js&"
import style0 from "./ReviewViewer.vue?vue&type=style&index=0&id=64833276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64833276",
  null
  
)

export default component.exports